import React, { useState, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { components } from 'react-select';

import { BotsCreators } from '../../../store/actions/bots';

import Select from '../../Select';
import HelpBallon from '../../Intelligence/component/HelpBalloon/HelpBalloon';

function HumanSettings(props) {
  const { doUpdateItem, item, queueAttendance, items, bot } = props;

  const [selectedHumanAttendance, setSelectedHumanAttendance] = useState(null);
  const [selectedHumanEscape, setSelectedHumanEscape] = useState(null);
  const [checkAgent, setCheckAgent] = useState(false);
  const [checkSchedule, setCheckSchedule] = useState(false);

  useEffect(() => {
    if (item) {
      setSelectedHumanAttendance(
        item.humanAttendance
          ? {
              value: item.humanAttendance._id,
              label: item.humanAttendance.name,
            }
          : null
      );
      setSelectedHumanEscape(
        item.humanEscape
          ? { value: item.humanEscape._id, label: item.humanEscape.title }
          : null
      );
      setCheckAgent(item.checkAgent || false);
      setCheckSchedule(item.respectSchedule || false);
    }
    return () => {
      setSelectedHumanAttendance(null);
      setSelectedHumanEscape(null);
    };
  }, [item]);

  const humanEscapeOptionsToSelect = useMemo(() => {
    if (!items) return [];

    const itemsFiltered = items.filter((i) => {
      return item._id !== i._id;
    })
    // eslint-disable-next-line no-shadow
    return itemsFiltered.map((item) => ({ value: item._id, label: item.title }));
  }, [items]);

  const OptionHumanEscape = (optionProps) => {
    const { data } = optionProps;
    return (
      <components.Option {...optionProps}>
        <strong>{data.label}</strong>
        <br />
        <span>{data.value}</span>
      </components.Option>
    );
  };

  const handleChangeHumanEscape = (option) => {
    if (!option) {
      doUpdateItem({ humanEscape: null });
      setSelectedHumanEscape(null);
      return;
    }

    setSelectedHumanEscape(option);
    doUpdateItem({ humanEscape: { _id: option.value, title: option.label } });
  };

  const humanAttendaceOptionsToSelect = useMemo(() => {
    if (!queueAttendance) {
      return [];
    }
    return queueAttendance.map((attendance) => ({
      value: attendance._id,
      label: attendance.name,
      service: attendance.service,
    }));
  }, [queueAttendance]);

  const OptionHumanAttendance = (optionProps) => {
    const { data } = optionProps;
    return (
      <components.Option {...optionProps}>
        <span>Serviço: {data.service}</span>
        <br />
        {bot.settings.human.selected !== 'Omni' ? null : (
          <span>Canal: {data.label}</span>
        )}
      </components.Option>
    );
  };

  const handleChangeHumanAttendance = (option) => {
    if (!option) {
      doUpdateItem({ humanAttendance: null });
      setSelectedHumanAttendance(null);
      return;
    }

    setSelectedHumanAttendance(option);
    const humanAttendanceData = queueAttendance.find(
      (attendance) => attendance._id === option.value
    );
    doUpdateItem({ humanAttendance: humanAttendanceData });
  };

  const handleUpdateCheckAgent = (event) => {
    const { checked } = event.target;
    setCheckAgent(checked);
    doUpdateItem({ checkAgent: checked });
  };

  const handleUpdateCheckSchedule = (event) => {
    const { checked } = event.target;
    setCheckSchedule(checked);
    doUpdateItem({ respectSchedule: checked });
  };

  return (
    <div>
      <Select
        label="Fila de Atendimento:"
        options={humanAttendaceOptionsToSelect}
        value={selectedHumanAttendance}
        onChange={handleChangeHumanAttendance}
        isClearable
        components={{ Option: OptionHumanAttendance }}
      />

      <div className="form-group row mb-1">
        <div className="custom-control custom-switch mt-2">
          <input
            type="checkbox"
            className="custom-control-input"
            id="checkSchedule"
            checked={checkSchedule}
            onChange={handleUpdateCheckSchedule}
          />
          <label className="custom-control-label" htmlFor="checkSchedule">
            horário de atendimento
          </label>

          <HelpBallon
            id="help-ballon-check-agente"
            message="Se desativada, a Boteria transfere para a plataforma de atendimento mesmo fora do horário de atendimento."
          />
        </div>
      </div>

      <div className="form-group row mb-1">
        <div className="custom-control custom-switch mt-2">
          <input
            type="checkbox"
            className="custom-control-input"
            id="checkAgent"
            checked={checkAgent}
            onChange={handleUpdateCheckAgent}
          />
          <label className="custom-control-label" htmlFor="checkAgent">
            validação de agente online
          </label>

          <HelpBallon
            id="help-ballon-check-agente"
            message="Se desativada, a Boteria transfere para a plataforma de atendimento mesmo que não haja agentes online."
          />
        </div>
      </div>

      {checkAgent && (
        <Select
          label="Escape"
          options={humanEscapeOptionsToSelect}
          value={selectedHumanEscape}
          onChange={handleChangeHumanEscape}
          isClearable
          components={{ Option: OptionHumanEscape }}
        />
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  queueAttendance: state.bots.queueAttendance,
  items: state.items.list,
  bot: state.bots.bot,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...BotsCreators }, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(HumanSettings)
);
